import {
  collection,
  doc,
  getDocs,
  getFirestore,
  query,
  where,
} from "firebase/firestore";
import { ContentSchedule } from "../types";

export const getAllBrandsWithAllModules = async (): Promise<
  ContentSchedule[]
> => {
  const db = getFirestore();
  const brandsCollection = collection(db, "brands");

  const brandsQuery = query(brandsCollection, where("id", "!=", "korean"));
  const brandsSnapshot = await getDocs(brandsQuery);

  const brandPromises = brandsSnapshot.docs.map(async (brandDoc) => {
    const brandId = brandDoc.id;
    const brandDocRef = doc(db, "brands", brandId);
    const pagesCollection = collection(brandDocRef, "pages");
    const pagesSnapshot = await getDocs(pagesCollection);

    const modulePromises = pagesSnapshot.docs.map(async (pageDoc) => {
      const pageId = pageDoc.id;
      const modulesCollection = collection(
        brandDocRef,
        "pages",
        pageId,
        "modules",
      );
      const modulesSnapshot = await getDocs(modulesCollection);

      return modulesSnapshot.docs.map(
        (moduleDoc) =>
          ({
            id: moduleDoc.id,
            pageId,
            pageName: pageDoc.data().title,
            brandId,
            ...moduleDoc.data(),
          }) as ContentSchedule,
      );
    });

    const modulesArrays = await Promise.all(modulePromises);
    return modulesArrays.flat();
  });

  const allModulesArrays = await Promise.all(brandPromises);
  return allModulesArrays.flat();
};
